module.exports = __webpack_public_path__ + "static/media/InkFree.0801c08e.ttf";